<template>
  <div class="h-full overflow-scroll scrollbar scrollbar-small">
    <table class="w-full table-fixed">
      <thead class="border-b">
        <tr class="text-grey text-left">
          <th class="w-4/6 font-normal">Frage</th>
          <th class="w-2/6 font-normal">Ergebnisse</th>
        </tr>
      </thead>
      <tbody>
        <tr
          v-for="(agreement, index) in targetAgreements"
          :key="agreement.id"
          class="cursor-pointer"
          @click="() => showFullText(index)"
        >
          <td
            class="align-top pt-3 pr-14"
            :class="
              !fullTextRowsIndices.includes(index) ? 'show-first-two-lines' : ''
            "
          >
            {{ agreement.question }}
          </td>
          <td
            v-if="
              agreement.answer_type === 'grades' ||
                agreement.answer_type === 'freeText'
            "
            class="align-top pt-3"
          >
            <p
              :class="
                !fullTextRowsIndices.includes(index)
                  ? 'show-first-two-lines'
                  : ''
              "
            >
              {{ agreement.customer_review.answer ?? "Keine Antwort" }}
            </p>
          </td>
          <td v-else class="align-top pt-3">
            <ul v-if="getFilteredOptions(agreement).length > 0">
              <li
                v-for="option of getFilteredOptions(agreement)"
                :key="option.id"
                class="list-inside list-disc"
              >
                {{ option.text }}
              </li>
            </ul>
            <p v-else>Keine Antwort</p>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import { defineComponent, ref } from "vue";

export default defineComponent({
  props: {
    targetAgreements: {
      type: Array,
      required: true,
    },
  },
  setup() {
    const fullTextRowsIndices = ref([]);

    function showFullText(index) {
      if (fullTextRowsIndices.value.includes(index))
        fullTextRowsIndices.value = fullTextRowsIndices.value.filter(
          (i) => i !== index
        );
      else fullTextRowsIndices.value = [...fullTextRowsIndices.value, index];
    }

    function getFilteredOptions(agreement) {
      return agreement.customer_review.customerOptions.filter(
        (option) => option.is_checked
      );
    }

    return { fullTextRowsIndices, showFullText, getFilteredOptions };
  },
});
</script>

<style scoped>
.show-first-two-lines {
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
}
</style>
